var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { gql, useQuery } from '@apollo/client';
// TEAM_ARTICLE_CATEGORIES
var TEAM_ARTICLE_CATEGORIES = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query TeamArticleCategories($id: ID!) {\n    team(id: $id) {\n      id\n      article_categories {\n        id\n        name\n      }\n    }\n  }\n"], ["\n  query TeamArticleCategories($id: ID!) {\n    team(id: $id) {\n      id\n      article_categories {\n        id\n        name\n      }\n    }\n  }\n"])));
export var useTeamArticleCategoriesQuery = function (options) {
    return useQuery(TEAM_ARTICLE_CATEGORIES, options);
};
export default TEAM_ARTICLE_CATEGORIES;
var templateObject_1;
